import * as React from 'react';

export const Grille = (props: React.SVGProps<SVGPathElement>) => (
	<path id="GRILLE" stroke="#000" d="M197.735 65.516l5.74-12.118h40.182l4.21 12.118h-50.132z" {...props} />
);
